import dynamic from "next/dynamic";

const DynamicSearchOverlayModal = dynamic(
  () =>
    import("modules/common/components/navigation/SearchOverlay").then(
      (mod) => ({ default: mod.SearchOverlay })
    ),
  {
    loading: () => <></>,
  }
);

export default DynamicSearchOverlayModal;
